var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitButtonCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14775 9.69288L1.69435 6.38323C1.30622 6.01125 0.679234 6.01125 0.2911 6.38323C-0.0970335 6.75521 -0.0970335 7.3561 0.2911 7.72807L4.4511 11.7149C4.83923 12.0869 5.46622 12.0869 5.85435 11.7149L16.3837 1.62383C16.7719 1.25185 16.7719 0.650961 16.3837 0.278983C15.9956 -0.0929944 15.3686 -0.0929944 14.9805 0.278983L5.14775 9.69288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitButtonCheck);
export default __webpack_public_path__ + "static/media/submit_button_check.90acaccd4d577abb2fa888385d24cbe5.svg";
export { ForwardRef as ReactComponent };